/* eslint-disable */
(function() {
  var $ = require('jquery');

  function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  //map point click...
  $('.map')
    .find('.map-point')
    .click(function() {
      var $this = $(this);
      var $mapPopup = $('.map-popup');
      var $popupHeight = 0;
      var $pointPosition = $this.offset();
      var $ID = $this.attr('id');
      var $selectedPopup = $mapPopup.find('*[data-id=' + $ID + ']');
      var $selectedFilter = $('.map-filter').find('*[data-id=' + $ID + ']');

      //removes all active classes on filters then adds to selected item
      $('.map-filter ul li').removeClass('active');
      $selectedFilter.addClass('active');

      //hides all popup divs to start with by removing class active
      $('.map-popup .popup-content').removeClass('active');

      //adds class active to the one which is clicked and matches the attribute and id, then displays
      $selectedPopup.addClass('active');

      $popupHeight = getPopupHeight($selectedPopup);

      //show map function
      showMapPoint($mapPopup, $pointPosition, $popupHeight);
    });

  //Filter list item click...
  $('.map-filter')
    .find('ul li a')
    .click(function() {
      var $this = $(this);
      var $mapPopup = $('.map-popup');
      var $popupHeight = 0;
      var $ID = $this.parent().attr('data-id');
      var $selectedPopup = $mapPopup.find('*[data-id=' + $ID + ']');
      var $selectedMapPoint = $('#' + $ID);
      var $pointPosition = $selectedMapPoint.offset();

      //removes all active classes on filters then adds to selected item
      $('.map-filter ul li').removeClass('active');
      $this.parent().addClass('active');

      //hides all popup divs to start with by removing class active
      $('.map-popup .popup-content').removeClass('active');

      //adds class active to the one which is clicked and matches the attribute and id, then displays
      $selectedPopup.addClass('active');

      $popupHeight = getPopupHeight($selectedPopup);

      //show map function
      showMapPoint($mapPopup, $pointPosition, $popupHeight);

      return false;
    });

  function getPopupHeight($selectedPopup) {
    var height = 0;

    //displays the popup off the page
    //sets the height of the popup parent
    //returns back to top 0
    $selectedPopup.parent('.map-popup').css('top', '-9999px');
    height = $selectedPopup.parent('.map-popup').outerHeight() + 17;
    $selectedPopup.parent('.map-popup').css('top', '0px');

    return height;
  }

  function showMapPoint($mapPopup, $pointPosition, $popupHeight) {
    var $mapOffset = $('.map').offset();
    var $arrowPointerWidth = 208;

    if ($(window).innerWidth() < 992) {
      $arrowPointerWidth = 138;
    }

    //if popup has class opened
    //remove class and fade out popup
    if ($mapPopup.hasClass('opened')) {
      $mapPopup.removeClass('opened');
      //hides all
      $mapPopup.hide();
      //sets the position of the popup...
      //gets the top and left position of the point
      //gets the height of the popup and subtracts
      //gets the difference in offset between the map and point
      //adds class and fades in popup
      $mapPopup
        .css({
          top: $pointPosition.top - $popupHeight - $mapOffset.top,
          left: $pointPosition.left - $arrowPointerWidth - $mapOffset.left,
        })
        .addClass('opened')
        .fadeIn();
    } else {
      $mapPopup
        .css({
          top: $pointPosition.top - $popupHeight - $mapOffset.top,
          left: $pointPosition.left - $arrowPointerWidth - $mapOffset.left,
        })
        .addClass('opened')
        .fadeIn();
    }
  }

  //click on body to close popup unless clicked on map area
  if ($(window).innerWidth() > 767) {
    $(document).mouseup(function(e) {
      var popUp = $('.map');

      // if the target of the click isn't the container nor a descendant of the container
      if (!popUp.is(e.target) && popUp.has(e.target).length === 0) {
        $('.map-popup').removeClass('opened');
        $('.map-popup').hide();
        $('.map-filter ul li').removeClass('active');
      }
    });
  }

  //close icon closes popup on click
  $('.close-btn').click(function() {
    $(this)
      .closest('.map-popup')
      .fadeOut();
  });

  function filterDropdown() {
    var $mapFilter = $('.map-filter');
    var $mapPopup = $('.map-popup');

    //show first popup
    //set first child popup and filter li to have class of active until selecting another item
    $mapPopup.fadeIn();
    $mapPopup.find('.popup-content:first-child').addClass('active');
    $mapFilter.find('ul li:first-child').addClass('active');

    //Click to dropdown list of filters...
    $mapFilter.find('h3').click(function() {
      //if this doesn't have class open add it then slide down
      //otherwise remove and slide up
      if (!$(this).hasClass('slide-open')) {
        $(this).addClass('slide-open');
        $(this)
          .siblings('.link-wrap')
          .stop()
          .slideDown(600);
      } else {
        $(this).removeClass('slide-open');
        $(this)
          .siblings('.link-wrap')
          .stop()
          .slideUp(600);
      }
    });

    //filter item click...
    $mapFilter.find('ul li a').click(function() {
      if ($(window).innerWidth() < 768) {
        //removes class and slides filter up
        $('.map-filter h3').removeClass('slide-open');
        $('.map-filter h3')
          .siblings('.link-wrap')
          .stop()
          .slideUp(600);

        return false;
      }
    });
  }

  //IE8 Fallback shows first popup
  if ($('#page-wrapper').hasClass('IE8')) {
    var $mapFilter = $('.map-filter');
    var $mapPopup = $('.map-popup');

    //show first popup
    //set first child popup and filter li to have class of active until selecting another item
    $mapPopup.fadeIn();
    $mapPopup.find('.popup-content:first-child').show();
    $mapFilter.find('ul li:first-child').addClass('active');

    $mapFilter.find('ul li a').click(function() {
      if (
        $(this)
          .parent('li')
          .index() === 0
      ) {
        $mapPopup.find('.popup-content:first-child').show();
      } else {
        $mapPopup.find('.popup-content:first-child').hide();
      }
    });
  }

  if ($(window).innerWidth() < 768) {
    filterDropdown();
  }

  /* Store the window width */
  var windowWidth = $(window).width();

  /* Resize Event */
  $(window).resize(function() {
    // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
    if ($(window).width() !== windowWidth) {
      if ($(window).innerWidth() < 768) {
        if (windowWidth > 767) {
          //remove styles and unbind events
          $('.map-filter h3').unbind();
          $('.map-filter ul li').removeClass('active');
          $('.map-popup').removeAttr('style');
          $('.map-popup .popup-content').removeClass('active');
          $(document).unbind();
          filterDropdown();
        }
      } else {
        $('.map-filter .link-wrap').show();
      }

      // Update the window width for next time
      windowWidth = $(window).width();
    }
  });

  var $queryID = getParameterByName('location');

  if ($queryID.length > 0) {
    var $locationPoint = $('.inner-map').find('#location-' + $queryID);
    $locationPoint.click();
  }
})();
